import React from "react";
import { motion } from "framer-motion";

export default function CartSkeleton() {
  return (
    <div className="pt-20 sm:pt-24 pb-12 sm:pb-16 w-[98%] xs:w-[95%] sm:w-[92%] md:w-[90%] lg:max-w-[80%] mx-auto">
      {/* Header */}
      <div className="relative mb-6 sm:mb-8">
        <motion.div
          className="h-8 w-40 bg-gray-600/50 rounded"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.2, repeat: Infinity }}
        />
        <motion.div
          className="h-4 w-64 mt-2 bg-gray-600/40 rounded"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }}
        />
      </div>

      <div className="grid lg:grid-cols-3 gap-4 sm:gap-6">
        {/* Items list */}
        <div className="lg:col-span-2 space-y-3 sm:space-y-4">
          {Array.from({ length: 4 }).map((_, idx) => (
            <div
              key={idx}
              className="bg-white/5 border border-white/10 rounded-xl sm:rounded-2xl p-3 sm:p-4 md:p-5 flex gap-3 sm:gap-4"
            >
              <motion.div
                className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-lg sm:rounded-xl bg-gray-600/50"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: idx * 0.1 }}
              />
              <div className="flex-1 min-w-0">
                <motion.div
                  className="h-5 w-2/3 bg-gray-600/50 rounded"
                  animate={{ opacity: [0.5, 1, 0.5] }}
                  transition={{ duration: 1.2, repeat: Infinity, delay: 0.1 + idx * 0.1 }}
                />
                <div className="mt-3 flex items-center gap-3">
                  <motion.div
                    className="h-6 w-20 bg-gray-600/40 rounded-full"
                    animate={{ opacity: [0.5, 1, 0.5] }}
                    transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 + idx * 0.1 }}
                  />
                  <motion.div
                    className="h-4 w-24 bg-gray-600/30 rounded"
                    animate={{ opacity: [0.5, 1, 0.5] }}
                    transition={{ duration: 1.2, repeat: Infinity, delay: 0.3 + idx * 0.1 }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Summary */}
        <div className="h-fit lg:sticky lg:top-24">
          <div className="bg-white/5 border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:pb-6">
            <div className="flex items-center justify-between mb-3">
              <motion.div
                className="h-4 w-20 bg-gray-600/40 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity }}
              />
              <motion.div
                className="h-4 w-24 bg-gray-600/50 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }}
              />
            </div>
            <div className="flex items-center justify-between mb-4">
              <motion.div
                className="h-3 w-14 bg-gray-600/30 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: 0.1 }}
              />
              <motion.div
                className="h-3 w-28 bg-gray-600/30 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }}
              />
            </div>
            <div className="space-y-2">
              <motion.div
                className="h-10 w-full bg-gray-600/40 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: 0.1 }}
              />
              <motion.div
                className="h-10 w-full bg-gray-600/30 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: 0.2 }}
              />
              <motion.div
                className="h-10 w-full bg-gray-600/30 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.2, repeat: Infinity, delay: 0.3 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
